import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import {Grid} from 'react-bootstrap';
import Breadcrumbs from 'system/breadcrumbs';
import {Wrapper} from 'system/wrapper';
import Image from 'components/image';
import Spinner from '../../../spinner';
import DetailList from 'system/list/detail';
import {loadInstitutionDetail} from 'redux/actions/portal/institutions';
import communities from 'images/information-center/communities.svg';

const mapStateToProps = (state) => ({
  institutionDetail: state.institutions.get('institutionDetail'),
  isFetching: state.institutions.get('institutionsIsLoading'),
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (id) => dispatch(loadInstitutionDetail(id))
});


class CommunityDetail extends Component {

  renderImage = photo => photo
    ? <Image backgroundImage={photo} width="500px" maxWidth='100%' margin='-30px auto 20px'/>
    : <Image backgroundImage={communities} maxWidth='150px' margin='-30px auto 20px' alt="hospital"/>;

  componentDidMount() {
    this.props.onLoad(this.props.match.params.id)
  }

  render() {

    const item = this.props.institutionDetail;

    if (this.props.institutionDetail === undefined) {
      return (
        <Wrapper>
          <Spinner />
        </Wrapper>
      )
    }
    return (
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/infocenter">Інфоцентр</Link></li>
          <li><Link to="/infocenter/communities">Громадські організації</Link></li>
          <li><Link to={`/infocenter/communities/detail/${item.get('id')}`}>Організація {item.get('short_title')}</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>{item.get('full_title')}</h2>
            <DetailList>
              <li>{this.renderImage(item.get('photo'))}</li>
              <li><span>Адреса: </span>{item.get('address')}</li>
              <li style={{lineHeight: "1.3", textAlign: "justify", whiteSpace: "pre-wrap"}}><span>Про організацію: </span>{item.get('description')}</li>
            </DetailList>
          </Grid>
        </Wrapper>
      </div>
    )
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(CommunityDetail);



// WEBPACK FOOTER //
// ./src/system/information-center/communities/detail.js